/* unplugin-vue-components disabled */import { render } from "./UserSearchCompact.vue?vue&type=template&id=1225559c&scoped=true&ts=true"
import script from "./UserSearchCompact.vue?vue&type=script&lang=ts"
export * from "./UserSearchCompact.vue?vue&type=script&lang=ts"

import "./UserSearchCompact.vue?vue&type=style&index=0&id=1225559c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1225559c"]])

export default __exports__